module.exports = __webpack_public_path__ + "img/poam.8eb18461.png";